import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

const Sidebar = ({ onClose }) => {
  const handleLinkClick = () => {
    if (onClose) onClose();
  };

  return (
    <div className='left-0 top-0 h-screen w-full md:w-[20vw] border-r border-white/80 bg-white/70 backdrop-blur-md'>
      <div className='p-8 mt-20'>
        <div className='flex flex-col gap-3 font-[SourceSans] uppercase text-sm tracking-[0.12em] sm:text-base'>
          <NavLink to='/sell' end className={({ isActive }) => `flex items-center gap-3 rounded-xl p-3 transition-all ${isActive ? 'bg-red-600 text-white font-semibold' : 'text-neutral-700 hover:bg-white hover:text-neutral-900'}`} onClick={handleLinkClick} >
            <i className="ri-store-line"></i> Sell Books
          </NavLink>
          <NavLink to='/sell/list-products' className={({ isActive }) => `flex items-center gap-3 rounded-xl p-3 transition-all ${isActive ? 'bg-red-600 text-white font-semibold' : 'text-neutral-700 hover:bg-white hover:text-neutral-900'}`} onClick={handleLinkClick} >
            <i className="ri-history-line"></i> Sales History
          </NavLink>
          <NavLink to='/sell/orders' className={({ isActive }) => `flex items-center gap-3 rounded-xl p-3 transition-all ${isActive ? 'bg-red-600 text-white font-semibold' : 'text-neutral-700 hover:bg-white hover:text-neutral-900'}`} onClick={handleLinkClick} >
            <i className="ri-shopping-bag-line"></i> Orders
          </NavLink>
        </div>
      </div>
    </div>
  )
}

Sidebar.propTypes = {
  onClose: PropTypes.func
}

export default Sidebar
